/**
 * Created by Kaku.Guo on 2019/6/5.
 */
import { getMessage } from '../../components';

export const getReviewValidations = (messages, titleRequired = true, contentMaxLength = 1000, enableRating) => ({
    title: {
        rules: {
            required: value => (titleRequired ? !!value.trim().length : true),
            length: value => (titleRequired ? value.trim().length >= 5 && value.trim().length <= 100 : true)
        },
        messages: {
            required: getMessage(messages, 'messages.com.epicgames.plugin.store.validations.required'),
            length: getMessage(messages, 'messages.com.epicgames.plugin.store.validations.text.length', [5, 100])
        }
    },
    content: {
        rules: {
            required: value => (titleRequired ? !!value.replace(/<[^>]+>/g, '').trim().length : true),
            length: value => value.length >= 1 && value.replace(/<[^>]+>/g, '').length <= contentMaxLength
        },
        messages: {
            required: getMessage(messages, 'messages.com.epicgames.plugin.store.validations.required'),
            length: getMessage(messages, 'messages.com.epicgames.plugin.store.validations.text.length', [1, contentMaxLength])
        }
    },
    images: {
        rules: {
            length: value => !value || value.length <= 5
        },
        messages: {
            length: getMessage(messages, 'messages.com.epicgames.plugin.store.validations.image.length', [0, 5])
        }
    },
    rating: {
        rules: {
            required: value => (enableRating ? !!value : true)
        },
        messages: {
            required: getMessage(messages, 'messages.com.epicgames.plugin.store.validations.required')
        }
    }
});

export const getReviewReportValidations = (messages) => ({
    abuseType: {
        rules: {
            required: value => !!value
        },
        messages: {
            required: getMessage(messages, 'messages.com.epicgames.plugin.store.validations.required')
        }
    },
    content: {
        rules: {
            required: value => !!value.replace(/<[^>]+>/g, '').trim().length,
            length: value => value.length >= 5 && value.length <= 500
        },
        messages: {
            required: getMessage(messages, 'messages.com.epicgames.plugin.store.validations.required'),
            length: getMessage(messages, 'messages.com.epicgames.plugin.store.validations.text.length', [5, 500])
        }
    }
});
